<script setup lang="ts">
import { onClickOutside } from "@vueuse/core";

const props = defineProps<{
  image: any;
}>();

const { image } = props;

const getYoutubeThumbnailUrl = (image: any) => {
  if (image) {
    return `https://img.youtube.com/vi/${image.videoId}/0.jpg`;
  }
};

const isOpen = ref(false);

const openModal = () => {
  isOpen.value = true;
};

const closeModal = () => {
  isOpen.value = false;
};

const youtubeVideo = ref(null);

onClickOutside(youtubeVideo, () => (isOpen.value = false));
</script>

<template>
  <div class="relative">
    <NuxtImg
      loading="lazy"
      class="h-[20rem] md:h-[28.125rem] bg-white rounded-sm max-h-full w-full object-cover"
      :image-gallery="true"
      :src="getYoutubeThumbnailUrl(image)"
      @click="openModal"
    />
    <div
      class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-2xl text-white bg-red-500 rounded-full p-2.5 w-12 h-12 flex items-center justify-center"
      @click="openModal"
    >
      <i class="fa-solid fa-play"></i>
    </div>
    <div
      v-if="isOpen"
      ref="youtubeVideo"
      class="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center"
      @click="closeModal"
    >
      <div class="bg-white rounded p-4 w-[90%] h-[90%]">
        <iframe
          width="100%"
          height="100%"
          :src="`https://www.youtube.com/embed/${image.videoId}`"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>
